export default __webpack_public_path__ + "static/media/django.6e65c8c1.svg";